/**
 * @generated SignedSource<<fa7854933c9f03442f7d7f7e137fcfab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LastUpdatedAtColumn_ContentSubmissionFragment$data = {
  readonly lastUpdated: string | null | undefined;
  readonly " $fragmentType": "LastUpdatedAtColumn_ContentSubmissionFragment";
};
export type LastUpdatedAtColumn_ContentSubmissionFragment$key = {
  readonly " $data"?: LastUpdatedAtColumn_ContentSubmissionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"LastUpdatedAtColumn_ContentSubmissionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LastUpdatedAtColumn_ContentSubmissionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastUpdated",
      "storageKey": null
    }
  ],
  "type": "ContentSubmission",
  "abstractKey": null
};

(node as any).hash = "2ee84685c28e7c483bfc7cfd6d8200b2";

export default node;
